import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Input } from '../../../../common/html/input'
import { debounce } from '../../../../helpers/common'
import { DEFAULT_PAGE } from './constant'
import { changePage, selectPage, selectPageSize } from './store/slice'

const InputSearchTemplate = ({ callApi }) => {
  const dispatch = useDispatch()

  const plhSearch = UseI18n('preferenceSetting.SEARCH_TEMPLATE')

  const page = useSelector(selectPage)
  const pageSize = useSelector(selectPageSize)

  const [value, setValue] = useState('')

  useEffect(() => {
    callApi({
      Page: page,
      PageSize: pageSize,
      TemplateName: value.trim(),
    })
  }, [page, pageSize])

  const onChange = (e) => {
    setValue(e.target.value)
    dispatch(changePage(DEFAULT_PAGE))
    callApiSearch({
      Page: DEFAULT_PAGE,
      PageSize: pageSize,
      TemplateName: e.target.value.trim(),
    })
  }

  const callApiSearch = useCallback(
    debounce((param) => callApi(param), 500),
    [],
  )

  return <Input value={value} onChange={onChange} placeHolder={plhSearch} />
}

export default InputSearchTemplate
